<template>
    <div class="mobile-navigation-wrapper">
        <div class="mobile-navigation bg-white" :class="{ 'open': isMobileNavigationOpen }">
            <div v-show="isNavigationInitialized">
                <ul class="breadcrumb d-block p-0 m-0">
                    <li class="px-3 bg-danger pull-right" @click="closeNavigation()" :aria-label="$translate('Ceres::Template.closeIcon')">
                        <i class="fa fa-close" aria-hidden="true"></i>
                    </li>

                    <li class="breadcrumb-item pl-3" @click="slideTo(null, true)">
                        <i class="fa fa-home" aria-hidden="true"></i>
                    </li>
                </ul>
                <ul v-menu id="menu-1" class="mainmenu w-100 p-0 m-0 menu-active">
                    <li class="ddown bg-secondary" v-if="dataContainer1.parent && dataContainer1.parent.details" @click="slideTo(dataContainer1.parent && dataContainer1.parent.parent || null, true)">
                        <span class="nav-direction btn-up">
                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                        </span>
                        <a>{{ dataContainer1.parent.details[0].name }}</a>
                    </li>

                    <li class="ddown bg-primary" v-if="dataContainer1.parent && dataContainer1.parent.url">
                        <a :href="getCategoryUrl(dataContainer1.parent.url)"><strong>{{ $translate("Waldorfshop7::Template.AllFromCategory") }}</strong></a>
                        <span class="nav-direction">
                            <i class="fa fa-lg fa-chevron-circle-right" aria-hidden="true"></i>
                        </span>
                    </li>

                    <li class="ddown" :class="dataContainer1.parent && dataContainer1.parent.url ? 'bg-secondary' : 'bg-color-'+(index % 10)" v-for="(category, index) in dataContainer1.categories">
                        <a :href="getCategoryUrl(category.url)" @click="category.childCount ? slideTo(category, false, $event) : openCategory(category.url)">{{ category.details[0].name }}</a>
                        <span class="nav-direction" @click="category.childCount ? slideTo(category) : openCategory(category.url)">
                            <i class="fa" :class="category.childCount ? 'fa-chevron-right text-white' : ''" aria-hidden="true"></i>
                        </span>
                    </li>
                    <template v-if="dataContainer1.categories[0]">
                        <li class="ddown" v-for="number in dataContainer1.categories[0].siblingCount - dataContainer1.categories.length">
                            <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                        </li>
                    </template>
                    <template v-else-if="dataContainer1.parent">
                        <li class="ddown" v-for="number in dataContainer1.parent.childCount">
                            <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                        </li>
                    </template>
                    <li class="ddown bg-primary">
                      <a href="https://blog.waldorfshop.eu" class="mobile-blog">Blog</a>
                      <span class="nav-direction text-right">
                          <a href="https://www.facebook.com/waldorfshop" class="py-0 px-1" title="Facebook" target="_blank">
                            <lazy-img image-url="https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_facebook_header.webp" ></lazy-img>
                          </a>
                          <a href="https://www.instagram.com/waldorfshop.eu" class="py-0 px-1" title="Instagram" target="_blank">
                            <lazy-img image-url="https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_insta_header.webp"></lazy-img>
                          </a>
                          <a href="https://www.youtube.com/channel/UCt-FjyLXUCN_WPVhaJHSD7A" class="py-0 px-1" title="YouTube" target="_blank">
                            <lazy-img image-url="https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_youtube_header.webp"></lazy-img>
                          </a>
                        </span>
                    </li>
                    <client-only>
                      <li class="ddown">
                        <div v-if="hrefLangLinks.length > 0" class="m-3">
                          <strong class="mb-1 d-block">{{ $translate("Ceres::Template.headerSelectLanguage") }}</strong>
                          <a :href="hreflang.href" class="badge text-uppercase p-2" :class="{'badge-primary': isSameLanguage(hreflang.hreflang), 'text-secondary': !isSameLanguage(hreflang.hreflang)}" v-for="hreflang in hrefLangLinks">{{ hreflang.hreflang }}</a>
                        </div>
                        <span class="nav-direction">
                            <user-login-handler
                              :show-login="true"
                              :show-registration="false">
                                <a class="nav-link" data-toggle="modal" :aria-label="$translate('Ceres::Template.login')">
                                    <img class="mx-auto d-block" src="https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_login.svg">
                                    <span class="d-none d-sm-block">{{ $translate("Ceres::Template.login") }}</span>
                                </a>
                            </user-login-handler>
                          </span>
                      </li>
                    </client-only>
                </ul>

                <ul v-menu id="menu-2" class="mainmenu w-100 p-0 m-0">
                    <li class="ddown bg-secondary" v-if="dataContainer2.parent && dataContainer2.parent.details" @click="slideTo(dataContainer2.parent && dataContainer2.parent.parent || null, true)">
                        <span class="nav-direction btn-up">
                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                        </span>
                        <a>{{ dataContainer2.parent.details[0].name }}</a>
                    </li>

                    <li class="ddown bg-primary" v-if="dataContainer2.parent && dataContainer2.parent.url">
                        <a :href="getCategoryUrl(dataContainer2.parent.url)"><strong>{{ $translate("Waldorfshop7::Template.AllFromCategory") }}</strong></a>
                        <span class="nav-direction">
                            <i class="fa fa-lg fa-chevron-circle-right" aria-hidden="true"></i>
                        </span>
                    </li>

                    <li class="ddown" :class="dataContainer2.parent && dataContainer2.parent.url ? 'bg-secondary' : 'bg-color-'+(index % 10)" v-for="(category, index) in dataContainer2.categories">
                        <a :href="getCategoryUrl(category.url)" @click="category.childCount ? slideTo(category, false, $event) : openCategory(category.url)">{{ category.details[0].name }}</a>
                        <span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
                            <i class="fa" :class="category.childCount ? 'fa-chevron-right text-white' : ''" aria-hidden="true"></i>
                        </span>
                    </li>
                    <template v-if="dataContainer2.categories[0]">
                        <li class="ddown" v-for="number in dataContainer2.categories[0].siblingCount - dataContainer2.categories.length">
                            <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                        </li>
                    </template>
                    <template v-else-if="dataContainer2.parent">
                        <li class="ddown" v-for="number in dataContainer2.parent.childCount">
                            <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                        </li>
                    </template>
                    <li class="ddown bg-primary">
                        <a href="https://blog.waldorfshop.eu" class="mobile-blog">Blog</a>
                      <span class="nav-direction text-right">
                          <a href="https://www.facebook.com/waldorfshop" class="py-0 px-1" title="Facebook" target="_blank">
                            <lazy-img image-url="https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_facebook_header.webp" ></lazy-img>
                          </a>
                          <a href="https://www.instagram.com/waldorfshop.eu" class="py-0 px-1" title="Instagram" target="_blank">
                            <lazy-img image-url="https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_insta_header.webp"></lazy-img>
                          </a>
                          <a href="https://www.youtube.com/channel/UCt-FjyLXUCN_WPVhaJHSD7A" class="py-0 px-1" title="YouTube" target="_blank">
                            <lazy-img image-url="https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_youtube_header.webp"></lazy-img>
                          </a>
                        </span>
                    </li>
                    <client-only>
                      <li class="ddown">
                          <div v-if="hrefLangLinks.length > 0" class="m-3">
                            <strong class="mb-1 d-block">{{ $translate("Ceres::Template.headerSelectLanguage") }}</strong>
                            <a :href="hreflang.href" class="badge text-uppercase p-2" :class="{'badge-primary': isSameLanguage(hreflang.hreflang), 'text-secondary': !isSameLanguage(hreflang.hreflang)}" v-for="hreflang in hrefLangLinks">{{ hreflang.hreflang }}</a>
                          </div>
                        <span class="nav-direction">
                          <user-login-handler
                            :show-login="true"
                            :show-registration="false">
                              <a class="nav-link" data-toggle="modal" :aria-label="$translate('Ceres::Template.login')">
                                  <img class="mx-auto d-block" src="https://cdn02.plentymarkets.com/rm2ukznxe8l9/frontend/Layout/icons2023/ws_icon_login.svg">
                                  <span class="d-none d-sm-block">{{ $translate("Ceres::Template.login") }}</span>
                              </a>
                          </user-login-handler>
                        </span>
                      </li>
                    </client-only>
                </ul>
            </div>

            <template v-if="!isNavigationInitialized">
                <ul class="breadcrumb">
                    <li class="btn-close" @click="closeNavigation()"></li>

                    <li class="breadcrumb-item">
                        <i class="fa fa-home" aria-hidden="true"></i>
                    </li>
                </ul>

                <loading-animation></loading-animation>
            </template>
        </div>
        <div class="mobile-navigation-overlay" @click="closeNavigation()"></div>
    </div>
</template>

<script>
import { MediaQueryHelper } from "../../helper/MediaQueryHelper";
import { isNullOrUndefined, isDefined } from "../../helper/utils";
import Vue from "vue";
import { mapState } from "vuex";

export default {

    props: {
        template: {
            default: "#vue-mobile-navigation",
            type: String
        },
        initialCategory: Object,
        breakpoints: {
            type: Array,
            default: () => ["xs", "sm", "md"]
        },
        includeLanguage: Boolean
    },

    data()
    {
        return {
            dataContainer1: {
                parent: {},
                categories: []
            },
            dataContainer2: {
                parent: {},
                categories: []
            },
            useFirstContainer: false,
            isNavigationInitialized: false,
            selectedCategory: null,
            hrefLangLinks: []
        };
    },

    computed:
    {
        breadcrumbs()
        {
            const breadcrumbs = [];
            let container = this.useFirstContainer ? this.dataContainer2 : this.dataContainer1;

            while (container && container.parent && Object.keys(container.parent).length)
            {
                breadcrumbs.unshift(
                    {
                        name: container.parent.details[0].name,
                        parent: container.parent || null
                    });

                container = container.parent;
            }

            return breadcrumbs;
        },

        ...mapState({
            navigationTree: state => state.navigation.tree,
            isMobileNavigationOpen: state => state.navigation.isMobileNavigationOpen
        })
    },

    created()
    {
        this.$store.commit("setCurrentCategory", this.initialCategory);
    },

    mounted()
    {
        this.addEventListener();
        this.getLanguageUrls();
    },

    methods:
    {
        addEventListener()
        {
            const QueryHelper = new MediaQueryHelper();
            const breakpoint = QueryHelper.getCurrentBreakpoint();

            QueryHelper.addFunction(this.loadInitialTree, this.breakpoints);

            if (this.breakpoints.includes(breakpoint))
            {
                this.loadInitialTree();
            }
        },

        loadInitialTree()
        {
            if (!this.isNavigationInitialized)
            {
                const categoryId = this.initialCategory && this.initialCategory.id ? this.initialCategory.id : null;

                this.$store.dispatch("loadPartialNavigationTree", { categoryId: categoryId })
                    .then(response =>
                    {
                        this.$store.commit("setNavigationTree", response);
                        this.initNavigation();
                    });
            }
        },

        initNavigation()
        {
            if (this.initialCategory && this.initialCategory.id)
            {
                if (this.initialCategory.linklist === "N")
                {
                    this.$store.commit("setCurrentCategory", this.initialCategory);
                }
                else
                {
                    this.$store.dispatch("setCurrentCategoryById", { categoryId: parseInt(this.initialCategory.id) });
                    this.initialSlide(this.$store.state.navigation.currentCategory);
                }
            }

            this.dataContainer1.parent = null;
            this.dataContainer1.categories = this.navigationTree;
            this.isNavigationInitialized = true;
        },

        initialSlide(currentCategory)
        {
            if (currentCategory)
            {
                if (currentCategory.children)
                {
                    this.slideTo(currentCategory);
                }
                else if (currentCategory.parent)
                {
                    this.slideTo(currentCategory.parent);
                }
            }
        },

        slideTo(category, back, event)
        {
            if (event) {
                event.preventDefault();
            }

            const children = isDefined(category) ? category.children : this.navigationTree;
            const categoryId = isDefined(category) ? category.id : null;

            this.loadPartialTree(categoryId);
            this.selectedCategory = category;

            if (this.useFirstContainer)
            {
                this.dataContainer1.parent = category;
                this.dataContainer1.categories = children || [];

                $("#menu-2").trigger("menu-deactivated", { back: !!back });
                $("#menu-1").trigger("menu-activated", { back: !!back });
            }
            else
            {
                this.dataContainer2.parent = category;
                this.dataContainer2.categories = children || [];

                $("#menu-1").trigger("menu-deactivated", { back: !!back });
                $("#menu-2").trigger("menu-activated", { back: !!back });
            }

            this.useFirstContainer = !this.useFirstContainer;
        },

        loadPartialTree(categoryId)
        {
            // eslint-disable-next-line eqeqeq
            if (this.selectedCategory != categoryId ||
                (isDefined(this.selectedCategory) && this.selectedCategory.id !== categoryId))
            {
                this.$store.dispatch("loadPartialNavigationTree", { categoryId: categoryId })
                    .then(response =>
                    {
                        if ((isNullOrUndefined(this.selectedCategory) && isNullOrUndefined(categoryId)) ||
                            (isDefined(this.selectedCategory) && this.selectedCategory.id === categoryId))
                        {
                            this.$store.commit("setNavigationTree", response);
                            this.updateDataContainers(categoryId);
                        }
                    });
            }
        },

        updateDataContainers(categoryId)
        {
            const containers = ["dataContainer1", "dataContainer2"];
            const category = this.getCategoryById(categoryId, this.navigationTree);

            for (const container of containers)
            {
                if (category)
                {
                    this[container].parent = category;
                    this[container].categories = category.children;
                }
                else
                {
                    // root level
                    this[container].parent = null;
                    this[container].categories = this.navigationTree;
                }
            }
        },

        getCategoryById(categoryId, tree)
        {
            for (const cat of tree)
            {
                if (categoryId === cat.id)
                {
                    return cat;
                }
                else if (cat.children)
                {
                    const foundCat = this.getCategoryById(categoryId, cat.children);

                    if (foundCat)
                    {
                        return foundCat;
                    }
                }
            }

            return null;
        },

        closeNavigation()
        {
            this.$store.commit("setIsMobileNavigationOpen", false);
        },

        getCategoryUrl(url)
        {
            const trailingSlash = url[0] === "/" ? "" : "/";
            const prefix = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

            return prefix + url;
        },

        openCategory(url)
        {
            window.location.href = this.getCategoryUrl(url);
        },

        getLanguageUrls()
        {
            this.hrefLangLinks = [];
            const hrefLangDefinitions = $('[hreflang]');
            for (const hreflang of hrefLangDefinitions) {
                if (hreflang.hreflang !== 'x-default') {
                    this.hrefLangLinks.push({hreflang: hreflang.hreflang, href: hreflang.href});
                }
            }
        },

        isSameLanguage(language)
        {
            return language === App.language;
        }
    },

    directives:
    {
        menu: {
            bind(el)
            {
                // add "activated" classes when menu is activated
                $(el).on("menu-activated", (event, params) =>
                {
                    $(event.target).addClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-in-from-left" : "animate-in-from-right");
                });
                // add "deactivated" classes when menu is deactivated
                $(el).on("menu-deactivated", (event, params) =>
                {
                    $(event.target).removeClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-out-to-right" : "animate-out-to-left");
                });
                // this removes the animation class automatically after the animation has completed
                $(el).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () =>
                {
                    $(".mainmenu").removeClass((index, className) =>
                    {
                        return (className.match(/(^|\s)animate-\S+/g) || []).join(" ");
                    });
                });
            }
        }
    }
}
</script>
